/**
 * SourceTabs — 복합 소스 탭 UI 공유 컴포넌트
 *
 * Step 2(데이터 소스), Step 3(전처리), Step 4(청킹)에서
 * 동일한 소스 탭 전환 UI를 재사용합니다.
 *
 * - 단일 소스일 때는 렌더링하지 않음 (sources.length <= 1)
 * - 복합 소스일 때 각 소스 탭 버튼 표시
 */

import React from 'react';
import { SourceType, SOURCE_LABELS } from './pipeline.types';

// 소스별 아이콘 (14px)
const ICONS: Record<SourceType, React.ReactNode> = {
  file: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
      <polyline points="13 2 13 9 20 9" />
    </svg>
  ),
  web: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  database: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    </svg>
  ),
};

interface SourceTabsProps {
  sources: SourceType[];
  active: SourceType;
  onChange: (source: SourceType) => void;
}

export function SourceTabs({ sources, active, onChange }: SourceTabsProps) {
  // 단일 소스면 탭 불필요
  if (sources.length <= 1) return null;

  return (
    <div className="tabs pipe-source-tabs">
      {sources.map((s) => (
        <button
          key={s}
          className={`pipe-source-tab${active === s ? ' active' : ''}`}
          onClick={() => onChange(s)}
        >
          {ICONS[s]}
          <span>{SOURCE_LABELS[s]}</span>
        </button>
      ))}
    </div>
  );
}
